import { signUp } from "config/firebaseWithFirestore";
import {
    getList as _getList,
    getAll as _getAll,
    add as _add,
    update as _update,
    getOneById as _getOneById,
    getAsync as _getAsync,
} from "../../api";

const BASE_URL = "/settings/users";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "name",
    orderDirection: "asc",
    pageNumber: 0,
    pageSize: 5,
};

export function getAll({ onSuccess, onError }) {
    _getAll({ url: BASE_URL, onSuccess, onError });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({ url: `${BASE_URL}/${id}`, onSuccess, onError });
}

export async function getOneByIdAsync(id) {
    return _getAsync({ url: `${BASE_URL}/${id}` });
}

export async function getOneByEmailAsync({ email }) {
    return _getAsync({ url: `${BASE_URL}/email/${email.trim().toLowerCase()}` });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function signUpUser({ email, password, onSuccess, onError }) {
    signUp(email, password)
        .then(onSuccess)
        .catch(({ message }) => {
            onError(message);
        });
}